import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import DeleteModalContent from "../../components/DeleteModalContent/DeleteModalContent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { loadFAQCategories } from "../FAQCategory/loadData";
import { AddFaq } from "./AddFAQ";
import { loadFAQs } from "./loadData";
import { FAQHeaders } from "./tableHeaders";

const FAQs = ({}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [FAQs, setFAQs] = useState([]);
  const [viewModalState, setViewModalState] = useState(false);
  const [viewModalData, setViewModalData] = useState({});
  const [opened, setOpened] = useState(false);
  const [update, setUpdate] = useState(false);
  const [editData, setEditData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [deleteModalState, setDeleteModalState] = useState(false);
  const [editModalState, setEditModalState] = useState(false);
  console.log("ye to open ho raha", opened);
  useEffect(() => {
    loadFAQs(setLoading).then(setFAQs);
  }, [location.pathname, update]);

  const [allFAQCategories, setAllFAQCategories] = useState([]);
  useEffect(() => {
    loadFAQCategories(setLoading).then(setAllFAQCategories);
  }, [location.pathname]);

  return (
    <AdminPage title="FAQs">
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"FAQ Details"}
        InternalComponent={
          <SpecificView
            name={viewModalData?.faqQuestion}
            type={viewModalData?.faqCategory?.faqCatName}
            description={viewModalData?.faqAnswer}
            date={viewModalData?.createdDate}
            status={viewModalData?.state}
            videoLink={viewModalData?.faqVideoUrl}
            videoName={viewModalData?.faqVideoName}
          />
        }
      />
      <ModalWrapper
        opened={deleteModalState}
        setOpened={setDeleteModalState}
        title={"Delete FAQ"}
        InternalComponent={
          <DeleteModalContent
            route={`faq/deleteFaq/${deleteData?._id}`}
            type={"FAQ"}
            setUpdate={setUpdate}
            setOpened={setDeleteModalState}
            setLoading={setLoading}
          />
        }
      />

      <AddFaq
        opened={opened}
        setOpened={setOpened}
        allFAQCategories={allFAQCategories}
        setUpdate={setUpdate}
        editData={editData}
        setEditData={setEditData}
        setEditModalState={setEditModalState}
        editModalState={editModalState}
        setLoading={setLoading}
      />

      <LoaderWrapper loading={loading}>
        <TableComponent
          headCells={FAQHeaders}
          rowData={FAQs}
          setViewModalData={setViewModalData}
          setViewModalState={setViewModalState}
          showAddButton={true}
          setOpened={setOpened}
          setEditData={setEditData}
          setEditModalState={setEditModalState}
          setDeleteData={setDeleteData}
          setDeleteModalState={setDeleteModalState}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default withTranslation()(FAQs);
